/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/common/app';

export default class AchievementCategoriesState {
	async refresh(clear = false, initial = false) {
		this.loading = initial;
		this.updating = true;
		m.redraw();

		if (clear || app.store.all('achievement_categories').length === 0) {
			// Get all achievement categories (and their achievements and levels, included automatically)
			this.achievement_categories = await app.store.find('achievement_categories');
		} else {
			this.achievement_categories = app.store.all('achievement_categories').sort((a, b) => {
				if (a.order() < b.order()) return -1;
				if (a.order() > b.order()) return 1;
				return 0;
			});
		}

		this.active_category = this.achievement_categories[0]?.id();

		this.loading = false;
		this.updating = false;
		if (!initial) {
			this.saved = true;
		}
		m.redraw();

		if (!initial) {
			setTimeout(() => {
				this.saved = false;
				m.redraw();
			}, 3000);
		}
	}
}
